import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ThinkColoredSvg } from './assets/think-colored.svg';

const ThinkColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={ThinkColoredSvg} ref={ref} {...args} />);

export default ThinkColoredIcon;
